import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const tracks = new Map()

const onEnded = object(listener, {
  type: 'ended',
  passive,
  task: (track) => {
    const { kind } = track

    tracks.get(kind).delete(track)
  }
})

export const get = async (window, constraints) => {
  const { navigator } = window
  const { mediaDevices } = navigator
  const media = await mediaDevices.getUserMedia(constraints)

  for (const track of media.getTracks()) {
    const { kind } = track

    if (!has(kind)) {
      tracks.set(kind, new Set())
    }

    onEnded.listen(track)
    tracks.get(kind).add(track)
  }

  return media
}

export const has = kind => {
  return tracks.get(kind)?.size > 0
}

export const stop = track => {
  track.stop()
}

export const cleanup = async () => {
  for (const [key, value] of tracks) {
    value.forEach(stop)

    tracks.get(key)?.delete(value)
  }
}